import React, { ReactNode } from 'react';
import { ApolloProvider as BaseApolloProvider } from '@apollo/client';
import { client } from '@ax/graphql';

interface ApolloProviderProps {
  children: ReactNode;
}

export const ApolloProvider: React.FC<ApolloProviderProps> = ({ children }) => (
  <BaseApolloProvider client={client}>{children}</BaseApolloProvider>
);
